import { useState } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import BarCodeComponentForRetail from "../../../lib/BarCodeComponentForRetail";
import { useTranslation } from "react-i18next";
import useSyncProgressStore from "../../../stores/useSyncProgressStore";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";
import POSLogo from "../../../assets/images/NewLogoCW.svg";
import LoadingScreen from "../../PointOfSale/Retail/SuperMarket/LoadingScreen";
import leftLoading from "../../../assets/images/opo.gif";
import { clock } from "../../../utils/clock";
import { useHistory } from "react-router-dom";
import { useEventBus } from "../../../lib/components/EventBusProvider";
import useAuthStore from "../../../stores/useAuthStore";
import useTransactionStore from "../../../stores/useTransactionStore";
import useAdvanceOrderStore from "../../../stores/useAdvanceOrderStore";
import useCartStore from "../../../stores/useCartStore";
import { message } from "antd";
import dayjs from "dayjs";

// Extracted components
import EstimatesView from "./EstimatesView";
import getCartTableColumns from "./cartTableColumns";
import SideMenuDrawer from "./SideMenuDrawer";
import HeaderBar from "./HeaderBar";
import CustomerBar from "./CustomerBar";
import IconMenu from "./IconMenu";
import QtyPricePanel from "./QtyPricePanel";
import VirtualKeyboardDrawer from "./VirtualKeyboardDrawer";
import CartSection from "./CartSection";
import BottomPanels from "./BottomPanels";

// Extracted hook
import useEstimateHandlers from "./hooks/useEstimateHandlers";

const SupermarketEstimate = (props) => {
  const { dispatchEvent } = useEventBus();
  const {
    showSaleType,
    setShowSaleType,
    isSaleTypeFlag,
    setIsSaleTypeFlag,
    selectedSaleType,
    setSelectedSaleType,
    tillData,
    clearProductSearchResults,
    setProductSearchInput,
    productSearchInput,
    open,
    setOpen,
    inputName,
    setInputName,
    setIsInputFocused,
    isInputFocused,
    productSearchInputRef,
    onBarcodeInput,
    setIsProductsFilter,
    setFilterDrawer,
    documentTypes,
    selectedDocumentType,
    setSelectedDocumentType,
    showDocumentPopup,
    setShowDocumentPopup,
    notesValue,
    setNotesValue,
    selectedProductInCart,
    setSelectedProductInCart,
    selectProductInCart,
    showPaymentMethods,
    setShowPaymentMethods,
    selectedRowKeys,
    setSelectedRowKeys,
    deleteProduct,
    customMixItems,
    setCustomMixItems,
    groupQty,
    setGroupQty,
    selectedProductForNotes,
    setSelectedProductForNotes,
    openSalesRep,
    setOpenSalesRep,
    realPrice,
    setRealPrice,
    firstInputValue,
    setFirstInputValue,
    selectedCustomMix,
    setSelectedCustomMix,
    existingGroupItems,
    setExistingGroupItems,
    setOverPayedAmount,
    overPayedAmount,
    amount,
    setAmount,
    setQtyNumberFlag,
    setStockList,
    stockList,
    keyboard,
    clearSelectedProductInCart,
    verifyStock,
    openDisplayParkedBillModal,
    filterDrawer,
    couponModalVisible,
    displayAddNewCustomer,
    validateGiftCard,
    displayCustomerSearch,
    displayEditOldCustomer,
    giftCardFlag,
    setGiftCardFlag,
    isGiftCardFlag,
    manualDiscountModalVisible,
    loyalityOtpModalVisible,
    cart,
    setDisplayCustomerSearch,
    setCloseCustomerFlag,
    setEditFlag,
    removeCutomer,
    showAddNewCustomerFields,
    showEditOldCustomerFields,
    manualDiscountForm,
    setManualDiscountInput,
    setSelectedManualDiscountTypeValue,
    setManualDiscountModalVisible,
    setIsGiftCardFlag,
    setAddToBagFlag,
    giftCardType,
    setGiftCardType,
    searchHistoryInput,
    setSearchhistoryInput,
    orderHistoryDetails,
    setOrderHistoryDetails,
    filtersFlag,
    setFiltersFlag,
    searchOrderHistory,
    modifyProductList,
    onChangeTotalQuantity,
    enterTotalQty,
    handleTotalQty,
    decreaseProductQty,
    increaseProductQty,
    handleRealPrice,
    enterRealPrice,
    showPayments,
    setShowPayments,
    setNumb,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    paymentModalInputRef,
    processOrder,
    paymentCardRef,
    filteredPaymentMethods,
    isShowingAll,
    setIsShowingAll,
    onChangeAmount,
    requestPayment,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    currenciesData,
    handleCashPayment,
    handleAmount,
    giftCardData,
    setGiftCardData,
    handleLoyaltyPayment,
    setCart,
    getFilteredPaymentMethods,
    setStartIndex,
    startIndex,
    setSelectedKeys,
    filterdParkedList,
    setFilterdParkedList,
    showOrderHistory,
    selectedSaleTypeData,
    setSelectedSaleTypeData,
    checkIsManualWeight,
    setIsSearchProducts,
    getMoreProducts,
    isProductsFilter,
    getSearchedProducts,
    productListCardRef,
    setIsProductsVisible,
    isProductsVisible,
    pickProduct,
    setKeyboardType,
    keyboardType,
    productsData,
    layoutName,
    setLayoutName,
    deleteCart,
    showCustomMix,
    setShowCustomMix,
    orderType,
    setOrderType,
    posSaleTypes,
    setPosSaleTypes,
    setCurrenciesData,
    closeProductPanel,
    isQtyUpdate,
    setIsQtyUpdate,
    customerSearchInput,
    setCustomerSearchInput,
    form,
    keyboardInputFields,
    setKeyboardInputFields,
    options,
    setOptions,
    searchInputRef,
    activeInput,
    setActiveInput,
    deleteReceipt,
    loading,
    setLoading,
    cardPaymnetStatus,
    setCardPaymnetStatus,
    setProductStock,
    cardPaymnetStatusPLB,
    setCardPaymnetStatusPLB,
    setTempCart,
    setShowCompleteSaleStock,
    setCompleteSaleStockData,
    processBillDiscounts,
    setLoader,
    processTotalManualDiscount,
    addProduct,
    retailCustomerFields,
    convertMetaDataToKeyValue,
    customerForm,
    autoEnablePanCustomer,
    autoEnableNriBilling,
    setViewCustomerValues,
    setSelectedEditOldCustomer,
    setDisplayEditOldCustomer,
    setDisplayAddNewCustomer,
    setIsViewMode,
  } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const { percent, promotionPercentage, productPercentage, productCategoryPercentage, resetProgress } = useSyncProgressStore();
  const colorVariable = process.env.REACT_APP_POSBACKGROUND_COLOR;
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const themeJSON = posConfig?.themeJSON && posConfig?.themeJSON !== "N" && Object.keys(posConfig?.themeJSON).length > 0 ? JSON.parse(posConfig?.themeJSON)?.layout4 : {};
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const userData = useAuthStore.getState().userData;
  const [dateRange, setDateRange] = useState([]);
  const [clock1, setClock1] = useState(clock());
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const version_number = process.env.REACT_APP_release_no || "24Q0.0.0";
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const customerId = tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId;
  const tillAccessData = tillData?.tillAccess;
  const showVirtualKeyboard = posConfig?.showKeyboard === "Y" ? true : false;
  const CWHardwareController = tillData.tillAccess.cwrTill.printTemplate.cwController === "Y" ? true : false;

  // ——— Extracted handlers hook ———
  const {
    // State
    tillLink,
    setTillLink,
    isOnline,
    isLocked,
    setIsLocked,
    isSectionVisible,
    notesPopup,
    setNotesPopup,
    showInputFields,
    setShowInputFields,
    groupName,
    setGroupName,
    returnFlag,
    setReturnFlag,
    isPurchaseReturn,
    setIsPurchaseReturn,
    viewStock,
    keyValue,
    setKeyValue,
    syncLoad,
    setSyncLoad,
    productItems,
    setProductItems,
    productArray,
    setProductArray,
    productsDisplay,
    estimateNo,
    setEstimateNo,
    productsList,
    setProductsList,
    productMap,
    setProductMap,
    isEstimatesFlag,
    setIsEstimatesFlag,
    activeEstimatesTab,
    setActiveEstimatesTab,
    loadingEstimates,
    estimatesData,
    searchEstimatesInput,
    setSearchEstimatesInput,
    expandedEstimatesRowKey,
    setExpandedEstimatesRowKey,
    isAdvanceOrderEnabled,
    setIsAdvanceOrderEnabled,
    productSearchRef,
    productPanelSearchRef,
    qtyInputRef,
    // Handlers
    errorMessage,
    handleCancel,
    showPreviousItems,
    modulo,
    removeProductModal,
    updateKeyboardInputs,
    onKeyPress,
    handleSelectProduct,
    handleSearch,
    onChangeInput,
    fetchEstimates,
    handleUpsertEstimate,
    handleRetrieveEstimate,
    handleDeletePayment,
    handleKeyvalue,
    showConfirm,
    showMoreItems,
    confirmUnlink,
    handleViewStockClick,
  } = useEstimateHandlers({
    tillData,
    cart,
    setCart,
    pricePrecision,
    amount,
    setAmount,
    overPayedAmount,
    giftCardData,
    setGiftCardData,
    handleLoyaltyPayment,
    selectedProductInCart,
    setSelectedProductInCart,
    setStockList,
    setProductSearchInput,
    keyboard,
    setSelectedPaymentMethod,
    setSelectedKeys,
    filterdParkedList,
    showOrderHistory,
    selectedSaleTypeData,
    resetProgress,
    searchHistoryInput,
    searchOrderHistory,
    dateRange,
    onBarcodeInput,
    setCustomerSearchInput,
    form,
    keyboardInputFields,
    setKeyboardInputFields,
    setLayoutName,
    layoutName,
    inputName,
    deleteCart,
    searchInputRef,
    setShowPaymentMethods,
    setOrderHistoryDetails,
    setProductStock,
    setTempCart,
    setShowCompleteSaleStock,
    setCompleteSaleStockData,
    getFilteredPaymentMethods,
    startIndex,
    setShowPayments,
    setStartIndex,
    cardPaymnetStatusPLB,
    setCardPaymnetStatusPLB,
    setOptions,
    productSearchInput,
    deleteProduct,
    setShowCustomMix,
    t,
    setOpenSalesRep,
    setDisplayCustomerSearch,
  });

  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  })}`;

  const handleDateSelect = (date, dateString) => {
    setSelectedDate(date);
    setCalendarVisible(false);
    if (searchInputRef?.current) searchInputRef.current.focus();
    const updatedCart = {
      ...cart,
      deliveryDate: (date && date.format("DD-MM-YYYY HH:mm:ss")) || "",
      deliveryDatePromised: (date && dateString) || "",
    };
    setCart(updatedCart);
  };

  const mainDivStyles = themeJSON.appBgImageURL
    ? { backgroundImage: `url(${themeJSON.appBgImageURL})`, height: "100vh", width: "100%", display: isLocked || isSectionVisible ? "none" : "block" }
    : { backgroundColor: colorVariable ? colorVariable : "#f3f4f9", height: "100vh", width: "100%", display: isLocked || isSectionVisible ? "none" : "block" };
  document.querySelectorAll("amt-dial-btn-market").forEach((element) => {
    element.style.backgroundColor = themeJSON.keyBoardColor;
  });

  let barcodeFlag = false;
  const inputElement = document.getElementById("sm-customer-search");
  const amountInput = document.getElementById("sm-amount-input");
  const totalAmountInout = document.getElementById("sm-total-amount-input");
  const inputFocused = inputElement === document.activeElement || amountInput === document.activeElement || totalAmountInout === document.activeElement;
  const approvalFlag = useTransactionStore.getState().approvalFlag ? useTransactionStore.getState().approvalFlag : "1";
  if (
    !couponModalVisible &&
    !displayAddNewCustomer &&
    !validateGiftCard &&
    !displayCustomerSearch &&
    !displayEditOldCustomer &&
    !giftCardFlag &&
    !filterDrawer &&
    !isGiftCardFlag &&
    !manualDiscountModalVisible &&
    !loyalityOtpModalVisible &&
    !inputFocused &&
    !showCustomMix &&
    approvalFlag === "1"
  ) {
    barcodeFlag = true;
  } else {
    barcodeFlag = false;
  }

  const cartItems = (cart?.items || []).filter((item) => item.weight !== 0);
  const hasExpandableRows = cartItems.some((item) => item.children && item.children.length > 0);

  // Build cart table columns via extracted helper
  const cartColumns = getCartTableColumns({
    posConfig,
    cart,
    pricePrecision,
    currenciesList,
    selectedProductInCart,
    selectProductInCart,
    selectedRowKeys,
    setShowPaymentMethods,
    clearSelectedProductInCart,
    removeProductModal,
    setIsInputFocused,
    setShowInputFields,
    setCustomMixItems,
    setGroupQty,
    setNotesPopup,
    setNotesValue,
    setSelectedProductForNotes,
    setOpenSalesRep,
  });

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#2F3856" }} spin />} spinning={loading}>
      <>
        {isEstimatesFlag ? (
          <EstimatesView
            colorVariable={colorVariable}
            isEstimatesFlag={isEstimatesFlag}
            setIsEstimatesFlag={setIsEstimatesFlag}
            activeEstimatesTab={activeEstimatesTab}
            setActiveEstimatesTab={setActiveEstimatesTab}
            searchEstimatesInput={searchEstimatesInput}
            setSearchEstimatesInput={setSearchEstimatesInput}
            loadingEstimates={loadingEstimates}
            estimatesData={estimatesData}
            expandedEstimatesRowKey={expandedEstimatesRowKey}
            setExpandedEstimatesRowKey={setExpandedEstimatesRowKey}
            fetchEstimates={fetchEstimates}
            handleRetrieveEstimate={handleRetrieveEstimate}
          />
        ) : !syncLoad ? (
          <div style={mainDivStyles}>
            {/* ——— TOP HEADER BAR ——— */}
            <HeaderBar
              themeJSON={themeJSON}
              colorVariable={colorVariable}
              userData={userData}
              isOnline={isOnline}
              formattedDateTime={formattedDateTime}
              showSaleType={showSaleType}
              selectedSaleType={selectedSaleType}
              cart={cart}
              setIsSaleTypeFlag={setIsSaleTypeFlag}
              setTillLink={setTillLink}
              setIsLocked={setIsLocked}
              setShowCustomMix={setShowCustomMix}
              posConfig={posConfig}
              deleteReceipt={deleteReceipt}
              history={history}
              errorMessage={errorMessage}
              isAdvanceOrderEnabled={isAdvanceOrderEnabled}
              handleAdvanceOrderToggle={(checked) => {
                const currentCart = useCartStore.getState().cart;
                if (currentCart?.items?.length > 0) {
                  message.warning("Please empty the cart before changing the Advance Order.");
                  return;
                }
                setIsAdvanceOrderEnabled(checked);
              }}
              setProductSearchInput={setProductSearchInput}
            />

            {barcodeFlag && <BarCodeComponentForRetail onScan={onBarcodeInput} setProductSearchInput={setProductSearchInput} productSearchInput={productSearchInput} />}

            <div style={{ display: "flex", height: "91vh" }}>
              {/* ——— LEFT SIDE ——— */}
              <CartSection
                posConfig={posConfig}
                options={options}
                productMap={productMap}
                pickProduct={pickProduct}
                productSearchInput={productSearchInput}
                setProductSearchInput={setProductSearchInput}
                setOptions={setOptions}
                keyboard={keyboard}
                filterDrawer={filterDrawer}
                searchInputRef={searchInputRef}
                clearProductSearchResults={clearProductSearchResults}
                onChangeInput={onChangeInput}
                setOpen={setOpen}
                setInputName={setInputName}
                setIsInputFocused={setIsInputFocused}
                onBarcodeInput={onBarcodeInput}
                productSearchInputRef={productSearchInputRef}
                setIsProductsFilter={setIsProductsFilter}
                setFilterDrawer={setFilterDrawer}
                cart={cart}
                themeJSON={themeJSON}
                estimateNo={estimateNo}
                setNotesPopup={setNotesPopup}
                setNotesValue={setNotesValue}
                cartItems={cartItems}
                hasExpandableRows={hasExpandableRows}
                selectedProductInCart={selectedProductInCart}
                cartColumns={cartColumns}
                qtyInputRef={qtyInputRef}
                setShowInputFields={setShowInputFields}
                setRealPrice={setRealPrice}
                setFirstInputValue={setFirstInputValue}
                setSelectedCustomMix={setSelectedCustomMix}
                setCustomMixItems={setCustomMixItems}
                setGroupName={setGroupName}
                setGroupQty={setGroupQty}
                setExistingGroupItems={setExistingGroupItems}
                setOverPayedAmount={setOverPayedAmount}
                setAmount={setAmount}
                pricePrecision={pricePrecision}
                selectProductInCart={selectProductInCart}
                setQtyNumberFlag={setQtyNumberFlag}
                setShowPaymentMethods={setShowPaymentMethods}
                setSelectedProductInCart={setSelectedProductInCart}
                setStockList={setStockList}
                handleUpsertEstimate={handleUpsertEstimate}
                deleteCart={deleteCart}
                openDisplayParkedBillModal={openDisplayParkedBillModal}
                setEstimateNo={setEstimateNo}
                currenciesList={currenciesList}
                isAdvanceOrderEnabled={isAdvanceOrderEnabled}
                calendarVisible={calendarVisible}
                setCalendarVisible={setCalendarVisible}
                selectedDate={selectedDate}
                handleDateSelect={handleDateSelect}
              />

              {/* ——— RIGHT SIDE ——— */}
              <div
                style={{
                  width: "35.6%",
                  padding: "0% 0% 0 0.4%",
                  borderRadius: "10px",
                  paddingBottom: "0",
                  height: "89vh",
                  marginRight: "1%",
                }}
              >
                {/* Customer search / display */}
                <CustomerBar
                  tillData={tillData}
                  cart={cart}
                  customerId={customerId}
                  retailCustomerFields={retailCustomerFields}
                  convertMetaDataToKeyValue={convertMetaDataToKeyValue}
                  customerForm={customerForm}
                  autoEnablePanCustomer={autoEnablePanCustomer}
                  autoEnableNriBilling={autoEnableNriBilling}
                  setViewCustomerValues={setViewCustomerValues}
                  setSelectedEditOldCustomer={setSelectedEditOldCustomer}
                  setDisplayEditOldCustomer={setDisplayEditOldCustomer}
                  setDisplayAddNewCustomer={setDisplayAddNewCustomer}
                  setIsViewMode={setIsViewMode}
                  setDisplayCustomerSearch={setDisplayCustomerSearch}
                  setCloseCustomerFlag={setCloseCustomerFlag}
                  showEditOldCustomerFields={showEditOldCustomerFields}
                  setEditFlag={setEditFlag}
                  removeCutomer={removeCutomer}
                  showAddNewCustomerFields={showAddNewCustomerFields}
                />

                <div style={{ display: "flex", fontSize: "1vw" }}>
                  {/* ——— LEFT ICON MENU ——— */}
                  <IconMenu
                    themeJSON={themeJSON}
                    posConfig={posConfig}
                    tillAccessData={tillAccessData}
                    cart={cart}
                    isOnline={isOnline}
                    selectedProductInCart={selectedProductInCart}
                    pricePrecision={pricePrecision}
                    manualDiscountForm={manualDiscountForm}
                    setManualDiscountInput={setManualDiscountInput}
                    setSelectedManualDiscountTypeValue={setSelectedManualDiscountTypeValue}
                    setManualDiscountModalVisible={setManualDiscountModalVisible}
                    setProductSearchInput={setProductSearchInput}
                    setAddToBagFlag={setAddToBagFlag}
                    setOpenSalesRep={setOpenSalesRep}
                    setIsEstimatesFlag={setIsEstimatesFlag}
                    openDisplayParkedBillModal={openDisplayParkedBillModal}
                    handleKeyvalue={handleKeyvalue}
                    errorMessage={errorMessage}
                    setReturnFlag={setReturnFlag}
                    setIsPurchaseReturn={setIsPurchaseReturn}
                  />

                  {/* ——— QTY/PRICE NUMPAD ——— */}
                  {/* BUG-2220: Estimates never take payment on this screen ("Total Amount To
                      Pay" saves/prints the estimate, per CartTotalsPanel.js) -- PaymentPanel
                      below was leftover-wired to the same showPaymentMethods flag that
                      scanner.js's "estimate found on scan" (barcode-retrieve-a-held-estimate)
                      path flips true, and nothing on this screen ever reset it back (that
                      reset, in useCartHandlers.js's addProduct, is gated on isBlindReceipt --
                      a Retail-return-only field Estimate carts never set). So retrieving a
                      held estimate by barcode, or any product scan afterward, got stuck
                      showing PaymentPanel's numpad (positioned high, right under the search
                      bar) instead of this one (positioned lower, below the product-detail
                      card) -- visually "the keypad jumping to the top". Since this screen has
                      no payment step at all, QtyPricePanel no longer hides for that flag. */}
                  <QtyPricePanel
                    showInputFields={showInputFields}
                    selectedProductInCart={selectedProductInCart}
                    cart={cart}
                    stockList={stockList}
                    setStockList={setStockList}
                    currenciesList={currenciesList}
                    pricePrecision={pricePrecision}
                    modifyProductList={modifyProductList}
                    handleViewStockClick={handleViewStockClick}
                    themeJSON={themeJSON}
                    qtyInputRef={qtyInputRef}
                    onChangeTotalQuantity={onChangeTotalQuantity}
                    enterTotalQty={enterTotalQty}
                    handleTotalQty={handleTotalQty}
                    decreaseProductQty={decreaseProductQty}
                    increaseProductQty={increaseProductQty}
                    setIsInputFocused={setIsInputFocused}
                    realPrice={realPrice}
                    setRealPrice={setRealPrice}
                    handleRealPrice={handleRealPrice}
                    enterRealPrice={enterRealPrice}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <LoadingScreen
              colorVariable={colorVariable}
              POSLogo={POSLogo}
              formattedDateTime={formattedDateTime}
              clock1={clock1}
              leftLoading={leftLoading}
              percent={percent}
              productCategoryPercentage={productCategoryPercentage}
              productPercentage={productPercentage}
              promotionPercentage={promotionPercentage}
            />
          </>
        )}

        {/* ——— SIDE MENU DRAWER ——— */}
        <SideMenuDrawer
          tillLink={tillLink}
          setTillLink={setTillLink}
          searchInputRef={searchInputRef}
          setActiveInput={setActiveInput}
          tillData={tillData}
          cart={cart}
          setCart={setCart}
          posConfig={posConfig}
          isOnline={isOnline}
          selectedSaleTypeData={selectedSaleTypeData}
          confirmUnlink={confirmUnlink}
          errorMessage={errorMessage}
          handleCancel={handleCancel}
          setSyncLoad={setSyncLoad}
          resetProgress={resetProgress}
          version_number={version_number}
          removeCustomer={removeCutomer}
        />

        {/* ——— VIRTUAL KEYBOARD DRAWER ——— */}
        <VirtualKeyboardDrawer
          open={open}
          showVirtualKeyboard={showVirtualKeyboard}
          setOpen={setOpen}
          keyboard={keyboard}
          layoutName={layoutName}
          setLayoutName={setLayoutName}
          inputName={inputName}
          updateKeyboardInputs={updateKeyboardInputs}
          onKeyPress={onKeyPress}
        />

        {/* ——— BOTTOM PANELS (Product Panel, Qty Update, Grouped Products, Retail Modals) ——— */}
        <BottomPanels
          isProductsVisible={isProductsVisible}
          closeProductPanel={closeProductPanel}
          isQtyUpdate={isQtyUpdate}
          setIsQtyUpdate={setIsQtyUpdate}
          checkIsManualWeight={checkIsManualWeight}
          setIsSearchProducts={setIsSearchProducts}
          getMoreProducts={getMoreProducts}
          productItems={productItems}
          setProductItems={setProductItems}
          selectProductInCart={selectProductInCart}
          setProductArray={setProductArray}
          isProductsFilter={isProductsFilter}
          getSearchedProducts={getSearchedProducts}
          productListCardRef={productListCardRef}
          productsDisplay={productsDisplay}
          setIsProductsVisible={setIsProductsVisible}
          pickProduct={pickProduct}
          filterDrawer={filterDrawer}
          setFilterDrawer={setFilterDrawer}
          productSearchInput={productSearchInput}
          setProductSearchInput={setProductSearchInput}
          setOpen={setOpen}
          keyboardType={keyboardType}
          setKeyboardType={setKeyboardType}
          productSearchInputRef={productSearchInputRef}
          clearProductSearchResults={clearProductSearchResults}
          productsData={productsData}
          productSearchRef={productSearchRef}
          handleSelectProduct={handleSelectProduct}
          productsList={productsList}
          setProductsList={setProductsList}
          setLayoutName={setLayoutName}
          productPanelSearchRef={productPanelSearchRef}
          setInputName={setInputName}
          keyboard={keyboard}
          searchInputRef={searchInputRef}
          stockList={stockList}
          setStockList={setStockList}
          selectedProductInCart={selectedProductInCart}
          setCart={setCart}
          addProduct={addProduct}
          increaseProductQty={increaseProductQty}
          decreaseProductQty={decreaseProductQty}
          removeProductModal={removeProductModal}
          showCustomMix={showCustomMix}
          setShowCustomMix={setShowCustomMix}
          cart={cart}
          customMixItems={customMixItems}
          setCustomMixItems={setCustomMixItems}
          groupName={groupName}
          setGroupName={setGroupName}
          groupQty={groupQty}
          setGroupQty={setGroupQty}
          existingGroupItems={existingGroupItems}
          setExistingGroupItems={setExistingGroupItems}
          selectedCustomMix={selectedCustomMix}
          setSelectedCustomMix={setSelectedCustomMix}
          orderType={orderType}
          setOrderType={setOrderType}
          posSaleTypes={posSaleTypes}
          setPosSaleTypes={setPosSaleTypes}
          currenciesData={currenciesData}
          setCurrenciesData={setCurrenciesData}
          setActiveInput={setActiveInput}
          setProductStock={setProductStock}
          showPreviousItems={showPreviousItems}
          showMoreItems={showMoreItems}
          setShowCompleteSaleStock={setShowCompleteSaleStock}
          setCompleteSaleStockData={setCompleteSaleStockData}
          processBillDiscounts={processBillDiscounts}
          setLoader={setLoader}
          processTotalManualDiscount={processTotalManualDiscount}
          allProps={props}
        />
      </>
    </Spin>
  );
};

export default SupermarketEstimate;
